import { render } from "./GroupReportParametres.vue?vue&type=template&id=7c115ca9"
import script from "./GroupReportParametres.vue?vue&type=script&lang=js"
export * from "./GroupReportParametres.vue?vue&type=script&lang=js"

import "./GroupReportParametres.vue?vue&type=style&index=0&id=7c115ca9&lang=css"

import exportComponent from "J:\\ei-projects\\ei-adult-front\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__